import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCountry$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCountry extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '213fc8e81e3484b942a3e4059e92da228680c8ea', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '53834879d1f4f7ee7bce21ea73b83fb29f48529e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'bba9186acf143976a961c6073955367fccbbadaa', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.11 5.5c1.5.098 2.967.485 4.32 1.14A14.2 14.2 0 0 0 15.87 8a10 10 0 0 0 1.61-.14v8.41a6 6 0 0 1-1.61.22 11.7 11.7 0 0 1-4.32-1.14A14.2 14.2 0 0 0 6.11 14a9.6 9.6 0 0 0-1.61.14V5.72a6 6 0 0 1 1.61-.22m0-1.5a7.9 7.9 0 0 0-2.78.52A.51.51 0 0 0 3 5v10.43a.49.49 0 0 0 .66.46 8 8 0 0 1 2.45-.4c3.54 0 6.22 2.5 9.76 2.5a7.9 7.9 0 0 0 2.78-.52A.53.53 0 0 0 19 17V6.57a.5.5 0 0 0-.66-.47 8 8 0 0 1-2.45.4C12.32 6.5 9.65 4 6.11 4", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-country", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-country"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-country":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCountry$1);
            }
            break;
    } });
}

const CosmosIconCountry = CosmosIconCountry$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCountry, defineCustomElement };
